module.exports = __webpack_public_path__ + "static/media/carousel-4.23c533c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel-4.jpg
// module id = 154
// module chunks = 1